import React, { useEffect } from 'react';
import { Coin, X } from '@phosphor-icons/react';
import { Button } from '../ui/Button';
import { cn } from '../../lib/utils';
import { BETA_FREE_CREDITS } from '../../lib/constants';
interface PaywallModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSeePackages: () => void;
}
export function PaywallModal({
  isOpen,
  onClose,
  onSeePackages
}: PaywallModalProps) {
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-0 sm:p-6" role="dialog" aria-modal="true" data-id="element-88">
      <div className="absolute inset-0 bg-dark-1/70 backdrop-blur-sm animate-in fade-in duration-200" onClick={onClose} data-id="element-89" />

      <div className={cn('relative w-full sm:max-w-[480px] bg-dark-2 border border-dark-4', 'rounded-t-2xl sm:rounded-2xl shadow-2xl', 'animate-in slide-in-from-bottom sm:zoom-in-95 sm:slide-in-from-bottom-0 fade-in duration-300')} data-id="element-90">
        {/* Close */}
        <button type="button" onClick={onClose} className="absolute top-4 right-4 text-light-3 hover:text-light-1 transition-colors -m-1 p-1 z-10" aria-label="Închide" data-id="element-91">
          <X size={22} weight="bold" data-id="element-92" />
        </button>

        <div className="px-6 pt-10 sm:pt-12 pb-6 text-center" data-id="element-93">
          <div className="mx-auto w-16 h-16 rounded-full bg-lime-5 border border-lime-4 flex items-center justify-center mb-4" data-id="element-94">
            <Coin size={32} weight="fill" className="text-lime-1" data-id="element-95" />
          </div>
          <h2 className="text-xl font-semibold text-light-1 mb-2" data-id="element-96">
            Mai ai nevoie de credite
          </h2>
          <p className="text-sm text-light-2 leading-relaxed" data-id="element-97">
            Ai consumat toate cele {BETA_FREE_CREDITS} de credite din pachetul
            tău Beta. Cumpără un pachet pentru a continua să trimiți oferte
            chiriașilor.
          </p>
          <p className="text-xs text-light-3 mt-3" data-id="element-98">
            ✓ Draftul ofertei tale rămâne salvat.
          </p>
        </div>

        <div className="px-6 pb-6 flex flex-col gap-2" data-id="element-99">
          <Button onClick={onSeePackages} className="w-full bg-lime-1 hover:bg-lime-2 text-dark-1 font-semibold h-11" data-id="element-100">
            Vezi pachete
          </Button>
          <Button onClick={onClose} variant="ghost" className="w-full text-light-2 hover:text-light-1 hover:bg-dark-3 h-11" data-id="element-101">
            Mai târziu
          </Button>
        </div>
      </div>
    </div>;
}